import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { HotelGroup as schema } from '@bingads-webui/hotel-odata-schemas';
import { OverridableToolbarView } from '@bingads-webui/toolbar';
import { gridOptionUtils } from '../hotel-center-service';
import paginationTemplate from '../assignment-utils/custom-pagination-template.pug';
import nameTemplate from './grid-column-name.pug';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const jsdata = globalContext.require('campaignui/feature/hotel-center-js-data/index');
const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');
const { filterOptionsFromSchema } = globalContext.require('component/bingads-grid/shared/schema-util');
const state = globalContext.require('component/state/index');

const pageSizes = [10, 20];
const gridToolbar = new OverridableToolbarView({
  items: [{
    type: 'search-box',
    id: 'search-box-filter',
  }],
  toolbarId: _.uniqueId('grid-toolbar-'),
}).render();

const filterConfig = {
  editor: {
    toolbar: gridToolbar,
  },
  searchBox: {
    field: 'Name',
    placeholder: i18n.getString('HotelCenter_Group_Search_Group_Label'),
    toolbar: gridToolbar,
  },
};

// dataSource post process
function dataPostProcess(resources, attrs) {
  if (!_.isArray(attrs)) {
    return [];
  }
  const subAccountIds = [];
  const subAccountLists = [];

  _.each(attrs, (item) => {
    item.ParentId = item.SubAccountId; // eslint-disable-line no-param-reassign
    if (_.indexOf(subAccountIds, item.SubAccountId) === -1) {
      subAccountIds.push(item.SubAccountId);
      subAccountLists.push({
        Id: item.SubAccountId,
        Name: item.SubAccountName,
        ParentId: 0,
      });
    }
  });

  attrs.unshift(...subAccountLists);

  return attrs;
}

// column configuration
const formatGroupItem = (groupName, associationCount) => {
  const formatGroupItemString = i18n.getString('HotelCenter_Assignment_GroupList_Item_Format', {
    groupName,
    associationCount,
  });

  return formatGroupItemString;
};

// plugin configuration
const plugins = {
  pagination: {
    pageSize: 10,
    availablePageSizes: pageSizes,
    enableRandomPage: false,
    template: paginationTemplate,
    pageNumberLabelText: i18n.getString('Grid_Page_Colon'),
    pageSizeText: i18n.getString('Grid_ShowRows'),
    totalPageCountText: i18n.getString('Grid_PageOf'),
  },
  uiBlocker: {
    el: $('.hotel-center-assignment__container'),
  },
  filter: filterConfig,
  filterState: {
    entity: filterOptionsFromSchema(schema),
  },
  dateFilter: {
    isComparisonEnabled: false,
    isCustomRangeEnabled: true,
  },
  tree: {
    toggleColumnName: 'Name',
    templateDecorator: celTemplate => ({ value }) => {
      const attributeText = value.Name.value;
      const isRoot = value.Name.SubAccountId === 0;

      return celTemplate(_.defaults({ i18n }, value.Name, {
        attributeText,
        isRoot,
        HotelAssociationCount: value.HotelAssociationCount,
      }));
    },
  },
};

// scrolling configuration
const scrolling = {
  virtualized: true,
  header: {
    type: 'sticky',
    offset() {
      return $('.hotel-groups-list-grid-toolbar').height();
    },
  },
};

export default class GridOptions {
  constructor() {
    const entitySet = gridOptionUtils.getEntitySetByName('hotelGroup');
    const isSubAccountLevel = state.get('subAccount_id') === '';

    $('.hotel-groups-list-grid-toolbar').append(gridToolbar.$el);
    plugins.filterState.container = $('.hotel-groups-list-grid-filter-state');

    _.extend(this, {
      i18n,
      name: 'HotelGroupsListGrid',
      scrolling,
      dataSource: {
        resource: jsdata.HotelGroup,
        entity: jsdata.HotelGroup,
        type: 'js-data',
        options: _.extend(isSubAccountLevel ? { afterFindAll: dataPostProcess } : {}, {
          entitySet,
          cacheResponse: false,
        }),
        schema,
        query: {
          $select: isSubAccountLevel ? 'Id,Name,SubAccountName,SubAccountId,HotelAssociationCount' : 'Id,Name,HotelAssociationCount',
        },
      },
      selection: { enabled: true },
      rows: { headRows: 'column-header-rows' },
      plugins,
      columns: [bingadsGridColumn({
        name: 'Name',
        sortable: 'Name',
        type: 'string',
        bodyClasses: ['col-Name'],
        property: {
          get(hotelGroup) {
            return hotelGroup;
          },
          key: 'Name',
        },
        template: (local) => {
          if (isSubAccountLevel) {
            const item = _.pick(local, 'hasChildren', 'depth', 'isExpanded', 'isRoot', 'value', 'isRoot');
            // format the string for leaf node
            if (!item.hasChildren) {
              item.value = _.has(local, 'HotelAssociationCount') ? formatGroupItem(item.value, local.HotelAssociationCount) : '[deleted]';
            }
            return nameTemplate(_.extend({ i18n }, item));
          }
          const hotelGroup = local.value;
          return formatGroupItem(hotelGroup.Name, hotelGroup.HotelAssociationCount);
        },
      })],
    });
  }
}
